import React from 'react';
import AppTitle from '../../../layouts/AppTitle';

const OrderFailed = () => {
  return (
    <div>
      <AppTitle title={'Order Failed'} from='Checkout' to='Order Confirmation' link='/' />

      <div className='container mt-8 mb-3'>
        <div className='alert alert-danger' role='alert'>
          <h4 className='alert-heading'>Payment Failed</h4>
          <p>
            We regret to inform you that your payment attempt was unsuccessful. If any amount has
            been deducted, don't worry—your money will be refunded soon, usually within 3-5 business
            days. Thank you for your patience.
          </p>

          <hr />
          <p className='mb-0'>
            Thank you for your patience, and we apologize for any inconvenience caused.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderFailed;
